import { LockKeyhole, LogOut } from "lucide-react";
import CustomModal from "./CustomModal";
import { PrimaryButton } from "../Button/PrimaryButton";
import { UPGRADE_URL } from "@/shared/utils/constants";
import SecondaryButton from "../Button/SecondaryButton";

const TrialExpiredModal = ({ isOpen }) => {
  const handleUpgrade = () => {
    window.open(UPGRADE_URL, "_blank", "noopener,noreferrer");
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.dispatchEvent(new Event("tokenExpired"));
    window.location.href = "/signup";
  };

  return (
    <CustomModal isOpen={isOpen} width="520px" className="!p-0">
      <div className="relative overflow-hidden rounded-2xl bg-white">
        <div className="flex flex-col items-center gap-5 px-8 py-9 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary-transparent text-secondary">
            <LockKeyhole size={30} />
          </div>

          <div className="flex flex-col gap-2">
            <h2 className="text-xl font-bold text-gray-900">
              Your Free Trial Has Ended
            </h2>
            <p className="text-sm leading-6 text-gray-500">
              Upgrade your plan to continue using SalesWorx and unlock access to
              campaigns, contacts, AI assistance, and sales automation
              workflows.
            </p>
          </div>

          <div className="w-full rounded-xl border border-gray-200 bg-gray-50 p-4 text-left">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              What happens next?
            </p>
            <p className="mt-1 text-sm text-gray-700">
              Your workspace data remains available. Upgrade now or request a
              trial extension from your SalesWorx account contact to resume
              activity.
            </p>
          </div>

          <div className="flex gap-2 items-center w-full">
            <PrimaryButton
              startContent={false}
              className="w-full !py-3 text-white"
              onClick={handleUpgrade}
            >
              Upgrade Now
            </PrimaryButton>
            <SecondaryButton
              title="Logout"
              className="w-full border border-error-500 text-error-500"
              onClick={handleLogout}
              icon={<LogOut size={16} className="text-error-500" />}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default TrialExpiredModal;
